/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceListItemDataSchema = z.object({
	id: z.string(),
	stripeInvoiceId: z.string(),
	number: z.string().nullable(),
	status: z.string(),
	total: z.number(),
	currency: z.string(),
	issuedAt: z.iso.datetime(),
	dueDate: z.iso.datetime().nullable(),
	metadata: z.record(z.string(), z.string()),
	hostedInvoiceUrl: z.string().nullable(),
	stripeDashboardUrl: z.string(),
	amountRemaining: z.number(),
	payments: z.array(
		z.object({
			id: z.string(),
			currency: z.string(),
			amount: z.number(),
			status: z.string(),
			paidAt: z.iso.datetime().nullable(),
			paymentMethod: z.union([z.literal('Jobilla Wallet'), z.literal('Card'), z.literal('Bank Transfer')])
				.nullable(),
			receiptNumber: z.string().nullable(),
			metadata: z.record(z.string(), z.string()),
		}),
	),
})

export type InvoiceListItemDataSchema = z.infer<typeof invoiceListItemDataSchema>
